// extracted by mini-css-extract-plugin
export default {"error":"error---jY0P5"};